import React, {useState} from 'react';

// StepIndicator component extracted to prevent re-creation on state updates
const StepIndicator = ({ steps, currentStep }) => (
    <div className="flex al-center" style={{ maxWidth: '800px', margin: '0 auto 2rem auto', justifyContent: 'space-between' }}>
        {steps.map((step, index) => (
            <React.Fragment key={step.id}>
                <div className="flex" style={{ flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                    <div style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: currentStep > step.id ? '#10b981' : currentStep === step.id ? 'var(--link)' : '#d1d5db',
                        color: 'white',
                        fontWeight: 'bold',
                        transition: 'all 0.3s'
                    }}>
                        {step.id}
                    </div>
                    <span style={{
                        marginTop: '0.5rem',
                        fontSize: '0.875rem',
                        fontWeight: '500',
                        color: currentStep >= step.id ? 'var(--text)' : '#9ca3af'
                    }}>
                        {step.name}
                    </span>
                </div>
                {index < steps.length - 1 && (
                    <div style={{
                        height: '4px',
                        flex: 1,
                        marginBottom: '1.5rem',
                        marginLeft: '0.5rem',
                        marginRight: '0.5rem',
                        backgroundColor: currentStep > step.id ? '#10b981' : '#d1d5db',
                        transition: 'all 0.3s'
                    }} />
                )}
            </React.Fragment>
        ))}
    </div>
);

// Step1Welcome component extracted to prevent re-creation on state updates
const Step1Welcome = ({ formData, setFormData, setCurrentStep }) => (
    <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>🛡️</div>
        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', color: 'var(--text)', marginBottom: '1rem' }}>
            Bienvenue sur votre espace diagnostic toiture
        </h1>
        <p style={{ fontSize: '1.2rem', color: 'var(--text)', opacity: 0.8, marginBottom: '2rem' }}>
            Votre assurance vous offre un diagnostic gratuit par intelligence artificielle pour vérifier l'état de votre toiture.
        </p>

        <div className="br10" style={{ 
            backgroundColor: 'var(--background-light)', 
            border: '2px solid var(--border)', 
            padding: '1.5rem',
            marginBottom: '2rem'
        }}>
            <h2 style={{ fontSize: '1.1rem', fontWeight: '600', color: 'var(--text)', marginBottom: '1rem' }}>
                Vos informations
            </h2>
            <div style={{ textAlign: 'left' }}>
                <div className="flex al-center" style={{ marginBottom: '0.75rem' }}>
                    <div className="br05" style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: 'rgba(59, 130, 246, 0.1)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '0.75rem'
                    }}>
                        <span style={{ fontSize: '1.2rem' }}>👤</span>
                    </div>
                    <span style={{ color: 'var(--text)' }}>{formData.firstName} {formData.lastName}</span>
                </div>
                <div style={{ marginBottom: '0.75rem' }}>
                    <div className="flex al-center" style={{ marginBottom: '0.5rem' }}>
                        <div className="br05" style={{
                            width: '32px',
                            height: '32px',
                            backgroundColor: 'rgba(59, 130, 246, 0.1)',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: '0.75rem'
                        }}>
                            <span style={{ fontSize: '1.2rem' }}>📍</span>
                        </div>
                        <span style={{ color: 'var(--text)', fontWeight: '600' }}>Adresse</span>
                    </div>
                    <div style={{ paddingLeft: '2.5rem' }}>
                        <input
                            type="text"
                            value={formData.address}
                            onChange={(e) => setFormData({...formData, address: e.target.value})}
                            placeholder="Adresse"
                            style={{
                                width: '100%',
                                padding: '0.5rem',
                                border: '1px solid var(--border)',
                                borderRadius: '0.3rem',
                                marginBottom: '0.5rem',
                                fontSize: '1rem',
                                textAlign: 'left'
                            }}
                        />
                        <div className="flex" style={{ gap: '0.5rem' }}>
                            <input
                                type="text"
                                value={formData.zipCode}
                                onChange={(e) => setFormData({...formData, zipCode: e.target.value})}
                                placeholder="Code postal"
                                style={{
                                    width: '30%',
                                    padding: '0.5rem',
                                    border: '1px solid var(--border)',
                                    borderRadius: '0.3rem',
                                    fontSize: '1rem',
                                    textAlign: 'left'
                                }}
                            />
                            <input
                                type="text"
                                value={formData.city}
                                onChange={(e) => setFormData({...formData, city: e.target.value})}
                                placeholder="Ville"
                                style={{
                                    width: '70%',
                                    padding: '0.5rem',
                                    border: '1px solid var(--border)',
                                    borderRadius: '0.3rem',
                                    fontSize: '1rem',
                                    textAlign: 'left'
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="flex al-center" style={{ marginBottom: '0.75rem' }}>
                    <div className="br05" style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: 'rgba(59, 130, 246, 0.1)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '0.75rem'
                    }}>
                        <span style={{ fontSize: '1.2rem' }}>📞</span>
                    </div>
                    <span style={{ color: 'var(--text)' }}>{formData.phone}</span>
                </div>
                <div className="flex al-center">
                    <div className="br05" style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: 'rgba(59, 130, 246, 0.1)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '0.75rem'
                    }}>
                        <span style={{ fontSize: '1.2rem' }}>✉️</span>
                    </div>
                    <span style={{ color: 'var(--text)' }}>{formData.email}</span>
                </div>
            </div>
        </div>

        <div className="br10" style={{
            backgroundColor: 'rgba(16, 185, 129, 0.1)',
            border: '1px solid rgba(16, 185, 129, 0.3)',
            padding: '1rem',
            marginBottom: '2rem'
        }}>
            <p style={{ fontSize: '0.875rem', color: '#059669', margin: 0 }}>
                ✓ Ces informations sont issues de votre contrat d'assurance
            </p>
        </div>

        <button
            onClick={() => setCurrentStep(2)}
            className="br10"
            style={{
                backgroundColor: 'var(--link)',
                color: 'white',
                fontWeight: 'bold',
                padding: '1rem 2rem',
                fontSize: '1.1rem',
                border: 'none',
                cursor: 'pointer',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.target.style.opacity = '0.9'}
            onMouseOut={(e) => e.target.style.opacity = '1'}
        >
            Continuer vers le diagnostic
        </button>
    </div>
);

// Step2Diagnostic component extracted to prevent re-creation on state updates
const Step2Diagnostic = ({ diagLaunched, handleDiagnostic, progressSteps, currentProgressStep }) => (
    <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>🔍</div>
        <h1 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: 'var(--text)', marginBottom: '1rem' }}>
            Diagnostic par intelligence artificielle
        </h1>

        {!diagLaunched ? (
            <>
                <p style={{ fontSize: '1.1rem', color: 'var(--text)', opacity: 0.8, marginBottom: '2rem' }}>
                    Notre système d'analyse par satellite va examiner votre toiture en quelques secondes pour détecter :
                </p>

                <div className="grid" style={{ 
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '1rem',
                    marginBottom: '2rem'
                }}>
                    <div className="br10" style={{
                        backgroundColor: 'white',
                        border: '2px solid var(--border)',
                        padding: '1rem'
                    }}>
                        <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>📐</div>
                        <h3 style={{ fontWeight: '600', color: 'var(--text)', marginBottom: '0.5rem', fontSize: '1rem' }}>
                            Surface et configuration
                        </h3>
                        <p style={{ fontSize: '0.875rem', color: 'var(--text)', opacity: 0.7, margin: 0 }}>
                            Nombre de pans, superficie exacte
                        </p>
                    </div>
                    <div className="br10" style={{
                        backgroundColor: 'white',
                        border: '2px solid var(--border)',
                        padding: '1rem'
                    }}>
                        <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🔍</div>
                        <h3 style={{ fontWeight: '600', color: 'var(--text)', marginBottom: '0.5rem', fontSize: '1rem' }}>
                            État général
                        </h3>
                        <p style={{ fontSize: '0.875rem', color: 'var(--text)', opacity: 0.7, margin: 0 }}>
                            Vétusté, usure, défauts visibles
                        </p>
                    </div>
                    <div className="br10" style={{
                        backgroundColor: 'white',
                        border: '2px solid var(--border)',
                        padding: '1rem'
                    }}>
                        <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>💧</div>
                        <h3 style={{ fontWeight: '600', color: 'var(--text)', marginBottom: '0.5rem', fontSize: '1rem' }}>
                            Risques d'infiltration
                        </h3>
                        <p style={{ fontSize: '0.875rem', color: 'var(--text)', opacity: 0.7, margin: 0 }}>
                            Zones sensibles détectées
                        </p>
                    </div>
                    <div className="br10" style={{
                        backgroundColor: 'white',
                        border: '2px solid var(--border)',
                        padding: '1rem'
                    }}>
                        <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🌿</div>
                        <h3 style={{ fontWeight: '600', color: 'var(--text)', marginBottom: '0.5rem', fontSize: '1rem' }}>
                            Mousses et dépôts
                        </h3>
                        <p style={{ fontSize: '0.875rem', color: 'var(--text)', opacity: 0.7, margin: 0 }}>
                            Présence de végétation
                        </p>
                    </div>
                </div>

                <div className="br10" style={{
                    backgroundColor: 'rgba(251, 191, 36, 0.1)',
                    border: '1px solid rgba(251, 191, 36, 0.3)',
                    padding: '1rem',
                    marginBottom: '2rem'
                }}>
                    <p style={{ fontSize: '0.875rem', color: '#d97706', margin: 0 }}>
                        ℹ️ Ce diagnostic reste une analyse automatisée. Une inspection humaine peut être recommandée selon les résultats.
                    </p>
                </div>

                <button
                    onClick={handleDiagnostic}
                    className="br10"
                    style={{
                        backgroundColor: '#10b981',
                        color: 'white',
                        fontWeight: 'bold',
                        padding: '1rem 2rem',
                        fontSize: '1.1rem',
                        border: 'none',
                        cursor: 'pointer',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.2s'
                    }}
                    onMouseOver={(e) => e.target.style.opacity = '0.9'}
                    onMouseOut={(e) => e.target.style.opacity = '1'}
                >
                    Lancer le diagnostic gratuit
                </button>
            </>
        ) : (
            <div style={{ padding: '2rem 0' }}>
                {/* Informational message */}
                <div className="br10" style={{
                    backgroundColor: 'rgba(59, 130, 246, 0.1)',
                    border: '1px solid rgba(59, 130, 246, 0.3)',
                    padding: '1rem',
                    marginBottom: '2rem'
                }}>
                    <p style={{ fontSize: '0.95rem', color: 'var(--link)', margin: 0, fontWeight: '500' }}>
                        ℹ️ L'analyse est en cours et peut prendre un peu de temps
                    </p>
                </div>

                {/* Progress steps display */}
                <div style={{ textAlign: 'left', maxWidth: '500px', margin: '0 auto' }}>
                    {progressSteps.map((step, index) => (
                        <div key={index} className="flex al-center" style={{ 
                            marginBottom: '1rem',
                            padding: '0.75rem',
                            backgroundColor: 'rgba(16, 185, 129, 0.05)',
                            borderRadius: '0.5rem'
                        }}>
                            <div style={{
                                width: '24px',
                                height: '24px',
                                borderRadius: '50%',
                                backgroundColor: '#10b981',
                                color: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '0.75rem',
                                flexShrink: 0,
                                fontSize: '0.9rem'
                            }}>
                                ✓
                            </div>
                            <span style={{ color: 'var(--text)', fontSize: '0.95rem' }}>{step.name}</span>
                        </div>
                    ))}
                    
                    {currentProgressStep && (
                        <div className="flex al-center" style={{ 
                            marginBottom: '1rem',
                            padding: '0.75rem',
                            backgroundColor: 'rgba(59, 130, 246, 0.05)',
                            borderRadius: '0.5rem'
                        }}>
                            <div style={{
                                width: '24px',
                                height: '24px',
                                border: '3px solid var(--link)',
                                borderTopColor: 'transparent',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                marginRight: '0.75rem',
                                flexShrink: 0
                            }}></div>
                            <span style={{ color: 'var(--text)', fontSize: '0.95rem', fontWeight: '500' }}>
                                {currentProgressStep}
                            </span>
                        </div>
                    )}
                </div>

                <style>
                    {`
                        @keyframes spin {
                            to { transform: rotate(360deg); }
                        }
                    `}
                </style>
            </div>
        )}
    </div>
);

// Step3Results component extracted to prevent re-creation on state updates
const Step3Results = ({ setCurrentStep, setDiagLaunched, birdiaResult }) => {
    const [vggData, setVggData] = React.useState(null);
    const [vggProperties, setVggProperties] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const [hoveredRegion, setHoveredRegion] = React.useState(null);
    const [imageLoaded, setImageLoaded] = React.useState(false);
    const [imageDimensions, setImageDimensions] = React.useState({ width: 0, height: 0 });
    const [visibleRegions, setVisibleRegions] = React.useState({});

    // Fetch VGG data when component mounts
    React.useEffect(() => {
        if (!birdiaResult || !birdiaResult.vggUrl) {
            setLoading(false);
            setError('Aucune donnée VGG disponible');
            return;
        }

        const fetchVggData = async () => {
            try {
                console.log('[DEBUG] Fetching VGG data from:', birdiaResult.vggUrl);
                const response = await fetch(birdiaResult.vggUrl);
                if (!response.ok) {
                    throw new Error(`Failed to fetch VGG data: ${response.status}`);
                }
                const data = await response.json();
                console.log('[DEBUG] VGG data loaded:', data);
                setVggData(data);
                setLoading(false);
            } catch (err) {
                console.error('[ERROR] Error fetching VGG data:', err);
                setError(err.message);
                setLoading(false);
            }
        };

        fetchVggData();
    }, [birdiaResult]);

    // Parse and extract properties when vggData is loaded
    React.useEffect(() => {
        if (vggData) {
            const properties = parseVggProperties();
            setVggProperties(properties);
            
            // Initialize all regions as visible
            const regions = parseVggRegions();
            const initialVisibility = {};
            regions.forEach((region, index) => {
                initialVisibility[index] = true;
            });
            setVisibleRegions(initialVisibility);
        }
    }, [vggData]);
    
    // Toggle visibility of a single region
    const toggleRegionVisibility = (index) => {
        setVisibleRegions(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };
    
    // Toggle all regions visibility
    const toggleAllRegions = () => {
        const allVisible = Object.values(visibleRegions).every(v => v);
        const newVisibility = {};
        Object.keys(visibleRegions).forEach(key => {
            newVisibility[key] = !allVisible;
        });
        setVisibleRegions(newVisibility);
    };

    // Handle image load to get dimensions
    const handleImageLoad = (e) => {
        const img = e.target;
        setImageDimensions({
            width: img.naturalWidth,
            height: img.naturalHeight
        });
        setImageLoaded(true);
        console.log('[DEBUG] Image dimensions:', img.naturalWidth, 'x', img.naturalHeight);
    };

    // Parse VGG properties from nested objects
    const parseVggProperties = () => {
        console.log('[DEBUG_VGG_PROPS] ===== PARSING VGG PROPERTIES =====');
        
        if (!vggData) {
            console.log('[DEBUG_VGG_PROPS] No vggData available');
            return [];
        }
        
        const vggArray = Array.isArray(vggData) ? vggData : [vggData];
        console.log('[DEBUG_VGG_PROPS] Number of VGG objects:', vggArray.length);
        
        const allProperties = [];
        
        vggArray.forEach((vggObject, vggIndex) => {
            if (!vggObject) {
                return;
            }
            
            // Handle nested UUID structure
            const objectKeys = Object.keys(vggObject);
            if (objectKeys.length > 0) {
                const firstKey = objectKeys[0];
                
                if (vggObject[firstKey] && typeof vggObject[firstKey] === 'object') {
                    const nestedData = vggObject[firstKey];
                    
                    // Check if properties exist
                    if (nestedData.properties) {
                        console.log(`[DEBUG_VGG_PROPS] Found properties in VGG object ${vggIndex + 1}:`, nestedData.properties);
                        allProperties.push({
                            id: firstKey,
                            ...nestedData.properties
                        });
                    } else {
                        console.log(`[DEBUG_VGG_PROPS] No properties in VGG object ${vggIndex + 1}`);
                    }
                }
            }
        });
        
        console.log('[DEBUG_VGG_PROPS] Total properties extracted:', allProperties.length);
        console.log('[DEBUG_VGG_PROPS] All properties:', allProperties);
        console.log('[DEBUG_VGG_PROPS] ===== END PARSING VGG PROPERTIES =====');
        
        return allProperties;
    };

    // Parse VGG regions and convert to polygons
    const parseVggRegions = () => {
        console.log('[DEBUG_VGG] ===== PARSING VGG REGIONS =====');
        
        if (!vggData) {
            console.log('[DEBUG_VGG] No vggData available');
            return [];
        }
        
        console.log('[DEBUG_VGG] vggData type:', Array.isArray(vggData) ? 'Array' : 'Object');
        console.log('[DEBUG_VGG] vggData:', vggData);
        
        // Check if vggData is an array (multiple VGG objects)
        const vggArray = Array.isArray(vggData) ? vggData : [vggData];
        console.log('[DEBUG_VGG] Number of VGG objects:', vggArray.length);
        
        // Collect all regions from all VGG objects
        const allRegions = [];
        
        vggArray.forEach((vggObject, vggIndex) => {
            console.log(`[DEBUG_VGG] Processing VGG object ${vggIndex + 1}:`, vggObject);
            
            if (!vggObject) {
                console.log(`[DEBUG_VGG] VGG object ${vggIndex + 1} is null or undefined`);
                return;
            }
            
            // ===== HANDLING NESTED UUID STRUCTURE =====
            // VGG format from Birdia has structure: { "uuid": { filename, size, regions, properties, file_attributes } }
            // We need to extract the actual VGG data from the nested object
            let actualVggData = vggObject;
            
            // Check if vggObject has a 'regions' property directly
            if (!vggObject.regions) {
                console.log(`[DEBUG_VGG] VGG object ${vggIndex + 1} has no direct 'regions' property`);
                console.log(`[DEBUG_VGG] Available properties:`, Object.keys(vggObject));
                
                // Try to find regions in nested structure (Birdia format)
                const objectKeys = Object.keys(vggObject);
                if (objectKeys.length > 0) {
                    const firstKey = objectKeys[0];
                    console.log(`[DEBUG_VGG] Checking nested object with key: ${firstKey}`);
                    
                    if (vggObject[firstKey] && typeof vggObject[firstKey] === 'object') {
                        console.log(`[DEBUG_VGG] Found nested object:`, vggObject[firstKey]);
                        
                        // Check for regions OR properties (some objects may only have properties)
                        if (vggObject[firstKey].regions || vggObject[firstKey].properties) {
                            if (vggObject[firstKey].regions) {
                                console.log(`[DEBUG_VGG] Found 'regions' in nested object ✓`);
                            } else {
                                console.log(`[DEBUG_VGG] No regions, but found 'properties' in nested object`);
                            }
                            actualVggData = vggObject[firstKey];
                        } else {
                            console.log(`[DEBUG_VGG] Nested object has neither 'regions' nor 'properties'`);
                            console.log(`[DEBUG_VGG] Nested object properties:`, Object.keys(vggObject[firstKey]));
                            return;
                        }
                    } else {
                        console.log(`[DEBUG_VGG] First key does not contain an object`);
                        return;
                    }
                } else {
                    console.log(`[DEBUG_VGG] VGG object is empty`);
                    return;
                }
            }
            // ===== END NESTED UUID STRUCTURE HANDLING =====
            
            const regionEntries = Object.entries(actualVggData.regions || {});
            console.log(`[DEBUG_VGG] VGG object ${vggIndex + 1} has ${regionEntries.length} regions`);
            
            // VGG format typically has regions with shape_attributes and region_attributes
            regionEntries.forEach(([key, region], regionIndex) => {
                console.log(`[DEBUG_VGG] Region ${regionIndex + 1} (key: ${key}):`, region);
                
                const shape = region.shape_attributes || {};
                const attributes = region.region_attributes || {};
                
                console.log(`[DEBUG_VGG]   - Shape type: ${shape.name || 'unknown'}`);
                console.log(`[DEBUG_VGG]   - Shape attributes:`, shape);
                console.log(`[DEBUG_VGG]   - Region attributes:`, attributes);
                
                const regionData = {
                    id: `${vggIndex}-${key}`, // Prefix with vgg index to ensure unique IDs
                    shape: shape,
                    attributes: attributes,
                    name: attributes.name || attributes.label || 'Unknown',
                    description: attributes.description || ''
                };
                
                console.log(`[DEBUG_VGG]   - Parsed region data:`, regionData);
                allRegions.push(regionData);
            });
        });
        
        console.log('[DEBUG_VGG] Total regions extracted:', allRegions.length);
        console.log('[DEBUG_VGG] All regions:', allRegions);
        console.log('[DEBUG_VGG] ===== END PARSING VGG REGIONS =====');
        
        return allRegions;
    };

    // Get color for object type
    const getObjectColor = (objectName) => {
        const colorMap = {
            'PANNEAU_PHOTOVOLTAIQUE': { fill: 'rgba(34, 197, 94, 0.3)', stroke: '#22c55e' }, // Green
            'TOITURE': { fill: 'rgba(239, 68, 68, 0.3)', stroke: '#ef4444' }, // Red
            'VELUX': { fill: 'rgba(251, 191, 36, 0.3)', stroke: '#fbbf24' }, // Amber/Yellow
            'MOISISSURE': { fill: 'rgba(139, 92, 246, 0.3)', stroke: '#8b5cf6' }, // Purple
            'USURE': { fill: 'rgba(249, 115, 22, 0.3)', stroke: '#f97316' }, // Orange
            'FISSURE': { fill: 'rgba(220, 38, 38, 0.3)', stroke: '#dc2626' }, // Dark red
            'CASSURE': { fill: 'rgba(185, 28, 28, 0.3)', stroke: '#b91c1c' }, // Darker red
            'OBSTACLE': { fill: 'rgba(107, 114, 128, 0.3)', stroke: '#6b7280' }, // Gray
            'CHEMINEE': { fill: 'rgba(75, 85, 99, 0.3)', stroke: '#4b5563' }, // Dark gray
            'HUMIDITE': { fill: 'rgba(59, 130, 246, 0.3)', stroke: '#3b82f6' }, // Blue
            'RISQUE_FEU': { fill: 'rgba(239, 68, 68, 0.4)', stroke: '#dc2626' }, // Bright red
            'OMBRE': { fill: 'rgba(31, 41, 55, 0.3)', stroke: '#1f2937' }, // Very dark gray
        };
        
        // Return color based on object name, default to cyan if not found
        return colorMap[objectName] || { fill: 'rgba(6, 182, 212, 0.3)', stroke: '#06b6d4' };
    };

    // Render SVG polygon from VGG shape data
    const renderShape = (region, index) => {
        console.log(`[DEBUG_VGG_RENDER] Rendering region ${index}:`, region);
        
        // Check if region is visible
        if (visibleRegions[index] === false) {
            console.log(`[DEBUG_VGG_RENDER]   - Region ${index} is hidden, skipping render`);
            return null;
        }
        
        const shape = region.shape;
        const shapeName = shape.name ? shape.name.toLowerCase() : '';
        console.log(`[DEBUG_VGG_RENDER]   - Shape name: ${shape.name} (normalized: ${shapeName})`);
        console.log(`[DEBUG_VGG_RENDER]   - Shape data:`, shape);
        
        // Get color for this object type
        const objectColor = getObjectColor(region.name);
        console.log(`[DEBUG_VGG_RENDER]   - Object name: ${region.name}, Color:`, objectColor);
        
        if (shapeName === 'polygon' && shape.all_points_x && shape.all_points_y) {
            // Polygon shape
            const points = shape.all_points_x.map((x, i) => `${x},${shape.all_points_y[i]}`).join(' ');
            const isHovered = hoveredRegion === index;
            
            console.log(`[DEBUG_VGG_RENDER]   - Polygon points (${shape.all_points_x.length} vertices):`, points);
            console.log(`[DEBUG_VGG_RENDER]   - Rendering POLYGON ✓`);
            
            return (
                <polygon
                    key={index}
                    points={points}
                    style={{
                        fill: isHovered ? 'rgba(255, 0, 0, 0.5)' : objectColor.fill,
                        stroke: isHovered ? '#ff0000' : objectColor.stroke,
                        strokeWidth: isHovered ? 3 : 2,
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                    }}
                    onMouseEnter={() => setHoveredRegion(index)}
                    onMouseLeave={() => setHoveredRegion(null)}
                    onClick={() => toggleRegionVisibility(index)}
                />
            );
        } else if (shapeName === 'rect') {
            // Rectangle shape
            const isHovered = hoveredRegion === index;
            
            console.log(`[DEBUG_VGG_RENDER]   - Rectangle: x=${shape.x}, y=${shape.y}, width=${shape.width}, height=${shape.height}`);
            console.log(`[DEBUG_VGG_RENDER]   - Rendering RECT ✓`);
            
            return (
                <rect
                    key={index}
                    x={shape.x}
                    y={shape.y}
                    width={shape.width}
                    height={shape.height}
                    style={{
                        fill: isHovered ? 'rgba(255, 0, 0, 0.5)' : objectColor.fill,
                        stroke: isHovered ? '#ff0000' : objectColor.stroke,
                        strokeWidth: isHovered ? 3 : 2,
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                    }}
                    onMouseEnter={() => setHoveredRegion(index)}
                    onMouseLeave={() => setHoveredRegion(null)}
                    onClick={() => toggleRegionVisibility(index)}
                />
            );
        } else if (shapeName === 'circle') {
            // Circle shape
            const isHovered = hoveredRegion === index;
            
            console.log(`[DEBUG_VGG_RENDER]   - Circle: cx=${shape.cx}, cy=${shape.cy}, r=${shape.r}`);
            console.log(`[DEBUG_VGG_RENDER]   - Rendering CIRCLE ✓`);
            
            return (
                <circle
                    key={index}
                    cx={shape.cx}
                    cy={shape.cy}
                    r={shape.r}
                    style={{
                        fill: isHovered ? 'rgba(255, 0, 0, 0.5)' : objectColor.fill,
                        stroke: isHovered ? '#ff0000' : objectColor.stroke,
                        strokeWidth: isHovered ? 3 : 2,
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                    }}
                    onMouseEnter={() => setHoveredRegion(index)}
                    onMouseLeave={() => setHoveredRegion(null)}
                    onClick={() => toggleRegionVisibility(index)}
                />
            );
        }
        
        console.log(`[DEBUG_VGG_RENDER]   - Shape type not supported or missing data - returning NULL ✗`);
        return null;
    };

    if (!birdiaResult) {
        return (
            <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
                <div style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>⚠️</div>
                <h1 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: 'var(--text)', marginBottom: '1rem' }}>
                    Aucune donnée disponible
                </h1>
                <p style={{ fontSize: '1.1rem', color: 'var(--text)', opacity: 0.8, marginBottom: '2rem' }}>
                    Veuillez d'abord lancer un diagnostic.
                </p>
                <button
                    onClick={() => {
                        setCurrentStep(1);
                        setDiagLaunched(false);
                    }}
                    className="br10"
                    style={{
                        backgroundColor: 'var(--link)',
                        color: 'white',
                        fontWeight: 'bold',
                        padding: '1rem 2rem',
                        fontSize: '1.1rem',
                        border: 'none',
                        cursor: 'pointer',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.2s'
                    }}
                    onMouseOver={(e) => e.target.style.opacity = '0.9'}
                    onMouseOut={(e) => e.target.style.opacity = '1'}
                >
                    Retour au début
                </button>
            </div>
        );
    }

    const regions = parseVggRegions();
    
    console.log('[DEBUG_VGG_RENDER] ===== REGIONS TO RENDER =====');
    console.log('[DEBUG_VGG_RENDER] Total regions:', regions.length);
    console.log('[DEBUG_VGG_RENDER] Image loaded:', imageLoaded);
    console.log('[DEBUG_VGG_RENDER] Image dimensions:', imageDimensions);
    console.log('[DEBUG_VGG_RENDER] VGG data available:', !!vggData);

    return (
        <div style={{ maxWidth: '90vvw', margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📊</div>
                <h1 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: 'var(--text)', marginBottom: '1rem' }}>
                    Résultats du diagnostic IA
                </h1>
                <p style={{ fontSize: '1.1rem', color: 'var(--text)', opacity: 0.8 }}>
                    Analyse de votre toiture par intelligence artificielle
                </p>
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', padding: '3rem' }}>
                    <div style={{
                        width: '48px',
                        height: '48px',
                        border: '4px solid var(--border)',
                        borderTopColor: 'var(--link)',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 1rem auto'
                    }}></div>
                    <p style={{ color: 'var(--text)', opacity: 0.8 }}>Chargement des données d'analyse...</p>
                </div>
            ) : error ? (
                <div className="br10" style={{
                    backgroundColor: 'rgba(239, 68, 68, 0.1)',
                    border: '1px solid rgba(239, 68, 68, 0.3)',
                    padding: '1.5rem',
                    marginBottom: '2rem',
                    textAlign: 'center'
                }}>
                    <p style={{ color: '#dc2626', margin: 0 }}>
                        ⚠️ Erreur lors du chargement des données: {error}
                    </p>
                </div>
            ) : (
                <>
                    {/* Properties display section */}
                    {vggProperties.length > 0 && (
                        <div style={{ marginBottom: '2rem' }}>
                            {vggProperties.map((props, index) => (
                                <div key={index} className="br10" style={{
                                    backgroundColor: 'white',
                                    border: '2px solid var(--border)',
                                    padding: '1.5rem',
                                    marginBottom: index < vggProperties.length - 1 ? '1rem' : '0'
                                }}>
                                    <h2 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--text)' }}>
                                        📋 Informations de la toiture {vggProperties.length > 1 ? `(${index + 1}/${vggProperties.length})` : ''}
                                    </h2>
                                    
                                    {/* Grid layout for properties */}
                                    <div className="grid" style={{
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                        gap: '1rem',
                                        marginBottom: '1rem'
                                    }}>
                                        {/* Surface */}
                                        {props.roof_area_in_m2 !== undefined && (
                                            <div className="br05" style={{
                                                padding: '1rem',
                                                backgroundColor: 'rgba(59, 130, 246, 0.05)',
                                                border: '1px solid rgba(59, 130, 246, 0.2)'
                                            }}>
                                                <div style={{ fontSize: '0.875rem', color: 'var(--text)', opacity: 0.7, marginBottom: '0.25rem' }}>
                                                    Surface de la toiture
                                                </div>
                                                <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'var(--link)' }}>
                                                    {props.roof_area_in_m2.toFixed(2)} m²
                                                </div>
                                            </div>
                                        )}
                                        
                                        {/* Global rate */}
                                        {props.global_rate_type !== undefined && (
                                            <div className="br05" style={{
                                                padding: '1rem',
                                                backgroundColor: props.global_rate_type === 'A' ? 'rgba(16, 185, 129, 0.05)' : 
                                                                 props.global_rate_type === 'B' ? 'rgba(251, 191, 36, 0.05)' : 
                                                                 'rgba(239, 68, 68, 0.05)',
                                                border: props.global_rate_type === 'A' ? '1px solid rgba(16, 185, 129, 0.3)' : 
                                                       props.global_rate_type === 'B' ? '1px solid rgba(251, 191, 36, 0.3)' : 
                                                       '1px solid rgba(239, 68, 68, 0.3)'
                                            }}>
                                                <div style={{ fontSize: '0.875rem', color: 'var(--text)', opacity: 0.7, marginBottom: '0.25rem' }}>
                                                    Note globale
                                                </div>
                                                <div style={{ 
                                                    fontSize: '1.5rem', 
                                                    fontWeight: 'bold', 
                                                    color: props.global_rate_type === 'A' ? '#10b981' : 
                                                           props.global_rate_type === 'B' ? '#f59e0b' : 
                                                           '#ef4444'
                                                }}>
                                                    {props.global_rate_type} ({props.global_rate_value !== undefined ? props.global_rate_value.toFixed(2) : 'N/A'})
                                                </div>
                                            </div>
                                        )}
                                        
                                        {/* Usure rate */}
                                        {props.usure_rate !== undefined && (
                                            <div className="br05" style={{
                                                padding: '1rem',
                                                backgroundColor: 'rgba(249, 115, 22, 0.05)',
                                                border: '1px solid rgba(249, 115, 22, 0.2)'
                                            }}>
                                                <div style={{ fontSize: '0.875rem', color: 'var(--text)', opacity: 0.7, marginBottom: '0.25rem' }}>
                                                    Taux d'usure
                                                </div>
                                                <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#f97316' }}>
                                                    {props.usure_rate.toFixed(2)}%
                                                </div>
                                            </div>
                                        )}
                                        
                                        {/* Moisissure rate */}
                                        {props.moisissure_rate !== undefined && (
                                            <div className="br05" style={{
                                                padding: '1rem',
                                                backgroundColor: 'rgba(139, 92, 246, 0.05)',
                                                border: '1px solid rgba(139, 92, 246, 0.2)'
                                            }}>
                                                <div style={{ fontSize: '0.875rem', color: 'var(--text)', opacity: 0.7, marginBottom: '0.25rem' }}>
                                                    Taux de moisissure
                                                </div>
                                                <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#8b5cf6' }}>
                                                    {props.moisissure_rate.toFixed(2)}%
                                                </div>
                                            </div>
                                        )}
                                        
                                        {/* Humidite rate */}
                                        {props.humidite_rate !== undefined && (
                                            <div className="br05" style={{
                                                padding: '1rem',
                                                backgroundColor: 'rgba(59, 130, 246, 0.05)',
                                                border: '1px solid rgba(59, 130, 246, 0.2)'
                                            }}>
                                                <div style={{ fontSize: '0.875rem', color: 'var(--text)', opacity: 0.7, marginBottom: '0.25rem' }}>
                                                    Taux d'humidité
                                                </div>
                                                <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#3b82f6' }}>
                                                    {props.humidite_rate.toFixed(2)}%
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    
                                    {/* Revetements */}
                                    {(props.revetement_1 || props.revetement_2) && (
                                        <div className="br05" style={{
                                            padding: '1rem',
                                            backgroundColor: 'rgba(0, 0, 0, 0.02)',
                                            border: '1px solid var(--border)',
                                            marginBottom: '1rem'
                                        }}>
                                            <div style={{ fontSize: '0.875rem', color: 'var(--text)', opacity: 0.7, marginBottom: '0.5rem', fontWeight: '600' }}>
                                                Revêtement(s)
                                            </div>
                                            <div className="flex" style={{ gap: '0.5rem', flexWrap: 'wrap' }}>
                                                {props.revetement_1 && (
                                                    <span className="br05" style={{
                                                        padding: '0.5rem 1rem',
                                                        backgroundColor: 'var(--link)',
                                                        color: 'white',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '500'
                                                    }}>
                                                        {props.revetement_1.replace('ROOF_', '').replace(/_/g, ' ')}
                                                    </span>
                                                )}
                                                {props.revetement_2 && (
                                                    <span className="br05" style={{
                                                        padding: '0.5rem 1rem',
                                                        backgroundColor: 'var(--link)',
                                                        color: 'white',
                                                        fontSize: '0.875rem',
                                                        fontWeight: '500'
                                                    }}>
                                                        {props.revetement_2.replace('ROOF_', '').replace(/_/g, ' ')}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    
                                    {/* Addresses */}
                                    {props.addresses && props.addresses.length > 0 && (
                                        <div className="br05" style={{
                                            padding: '1rem',
                                            backgroundColor: 'rgba(0, 0, 0, 0.02)',
                                            border: '1px solid var(--border)'
                                        }}>
                                            <div style={{ fontSize: '0.875rem', color: 'var(--text)', opacity: 0.7, marginBottom: '0.5rem', fontWeight: '600' }}>
                                                Adresse(s) concernée(s)
                                            </div>
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                                                {props.addresses.map((address, addrIndex) => (
                                                    <div key={addrIndex} style={{ fontSize: '0.9rem', color: 'var(--text)' }}>
                                                        📍 {address}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Show All / Hide All button */}
                    {vggData && regions.length > 0 && (
                        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                            <button
                                onClick={toggleAllRegions}
                                className="br10"
                                style={{
                                    backgroundColor: 'var(--link)',
                                    color: 'white',
                                    fontWeight: '600',
                                    padding: '0.75rem 1.5rem',
                                    fontSize: '1rem',
                                    border: 'none',
                                    cursor: 'pointer',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    transition: 'all 0.2s'
                                }}
                                onMouseOver={(e) => e.target.style.opacity = '0.9'}
                                onMouseOut={(e) => e.target.style.opacity = '1'}
                            >
                                {Object.values(visibleRegions).every(v => v) ? '👁️‍🗨️ Masquer tout' : '👁️ Afficher tout'}
                            </button>
                        </div>
                    )}

                    {/* Side-by-side container for image and table */}
                    <div className="flex" style={{ 
                        gap: '1.5rem', 
                        marginBottom: '2rem',
                        alignItems: 'flex-start'
                    }}>
                        {/* Image and overlay container */}
                        <div className="br10" style={{
                            position: 'relative',
                            backgroundColor: 'white',
                            border: '2px solid var(--border)',
                            padding: '1rem',
                            overflow: 'hidden',
                            flex: '0 0 70%'
                        }}>
                            <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                                {birdiaResult.imageUrl ? (
                                    <>
                                        <img
                                            src={birdiaResult.imageUrl}
                                            alt="Satellite view of roof"
                                            onLoad={handleImageLoad}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                display: 'block'
                                            }}
                                        />
                                        {(() => {
                                            console.log('[DEBUG_VGG_SVG] ===== SVG RENDERING CHECK =====');
                                            console.log('[DEBUG_VGG_SVG] imageLoaded:', imageLoaded);
                                            console.log('[DEBUG_VGG_SVG] vggData exists:', !!vggData);
                                            console.log('[DEBUG_VGG_SVG] Should render SVG:', imageLoaded && vggData);
                                            
                                            if (imageLoaded && vggData) {
                                                console.log('[DEBUG_VGG_SVG] Rendering SVG with viewBox:', `0 0 ${imageDimensions.width} ${imageDimensions.height}`);
                                                console.log('[DEBUG_VGG_SVG] Number of regions to render:', regions.length);
                                                console.log('[DEBUG_VGG_SVG] Calling renderShape for each region...');
                                                
                                                return (
                                                    <svg
                                                        style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            width: '100%',
                                                            height: '100%',
                                                            pointerEvents: 'all'
                                                        }}
                                                        viewBox={`0 0 ${imageDimensions.width} ${imageDimensions.height}`}
                                                        preserveAspectRatio="xMidYMid meet"
                                                    >
                                                        {regions.map((region, index) => {
                                                            const shape = renderShape(region, index);
                                                            console.log(`[DEBUG_VGG_SVG] Region ${index} rendered:`, shape ? 'SUCCESS ✓' : 'NULL (filtered out) ✗');
                                                            return shape;
                                                        })}
                                                    </svg>
                                                );
                                            } else {
                                                console.log('[DEBUG_VGG_SVG] NOT rendering SVG - conditions not met');
                                                return null;
                                            }
                                        })()}
                                    </>
                                ) : (
                                    <div style={{
                                        padding: '3rem',
                                        textAlign: 'center',
                                        backgroundColor: 'rgba(0,0,0,0.05)'
                                    }}>
                                        <p style={{ color: 'var(--text)', opacity: 0.6 }}>
                                            Image satellite non disponible
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Legend and detected objects */}
                        {vggData && regions.length > 0 && (
                            <div className="br10" style={{
                                backgroundColor: 'white',
                                border: '2px solid var(--border)',
                                padding: '1.5rem',
                                flex: '1',
                                overflowY: 'auto'
                            }}>
                                <h2 style={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--text)' }}>
                                    Éléments détectés ({regions.length})
                                </h2>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                    gap: '0.75rem'
                                }}>
                                    {regions.map((region, index) => {
                                        const objectColor = getObjectColor(region.name);
                                        const isVisible = visibleRegions[index] !== false;
                                        return (
                                            <div
                                                key={index}
                                                className="br05"
                                                style={{
                                                    padding: '0.75rem',
                                                    backgroundColor: hoveredRegion === index ? 'rgba(59, 130, 246, 0.4)' : 'rgba(0, 0, 0, 0.02)',
                                                    border: hoveredRegion === index ? `2px solid ${objectColor.stroke}` : `2px solid ${objectColor.stroke}`,
                                                    borderLeft: `4px solid ${objectColor.stroke}`,
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s',
                                                    opacity: isVisible ? 1 : 0.4,
                                                    textDecoration: isVisible ? 'none' : 'line-through'
                                                }}
                                                onMouseEnter={() => setHoveredRegion(index)}
                                                onMouseLeave={() => setHoveredRegion(null)}
                                                onClick={() => toggleRegionVisibility(index)}
                                            >
                                                <div style={{ fontWeight: '600', marginBottom: '0.25rem', color: 'var(--text)' }}>
                                                    {isVisible ? '👁️ ' : '👁️‍🗨️ '}{region.name}
                                                </div>
                                                {region.description && (
                                                    <div style={{ fontSize: '0.875rem', color: 'var(--text)', opacity: 0.7 }}>
                                                        {region.description}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Info box */}
                    <div className="br10" style={{
                        backgroundColor: 'rgba(59, 130, 246, 0.1)',
                        border: '1px solid rgba(59, 130, 246, 0.3)',
                        padding: '1rem',
                        marginBottom: '2rem',
                        textAlign: 'center'
                    }}>
                        <p style={{ fontSize: '0.875rem', color: 'var(--link)', margin: 0 }}>
                            ℹ️ Survolez les zones détectées pour les mettre en évidence • Cliquez pour afficher/masquer un layer
                        </p>
                    </div>
                </>
            )}

            {/* Action buttons */}
            <div style={{ textAlign: 'center' }}>
                <button
                    onClick={() => {
                        setCurrentStep(1);
                        setDiagLaunched(false);
                    }}
                    className="br10"
                    style={{
                        backgroundColor: 'var(--link)',
                        color: 'white',
                        fontWeight: 'bold',
                        padding: '1rem 2rem',
                        fontSize: '1.1rem',
                        border: 'none',
                        cursor: 'pointer',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.2s'
                    }}
                    onMouseOver={(e) => e.target.style.opacity = '0.9'}
                    onMouseOut={(e) => e.target.style.opacity = '1'}
                >
                    Nouvelle analyse
                </button>
            </div>

            <style>
                {`
                    @keyframes spin {
                        to { transform: rotate(360deg); }
                    }
                `}
            </style>
        </div>
    );
};

const RoofAnalyserIa = () => {
    const [currentStep, setCurrentStep] = useState(1);
    const [diagLaunched, setDiagLaunched] = useState(false);
    const [formData, setFormData] = useState({
        firstName: 'Jean',
        lastName: 'Dupont',
        email: 't.monteiro@tegeo.fr',
        phone: '06 12 34 56 78',
        address: '1 Rue De La Vau Saint-Jacques',
        city: 'Parthenay',
        zipCode: '79200'
    });
    
    // Progress tracking states
    const [progressSteps, setProgressSteps] = useState([]);
    const [currentProgressStep, setCurrentProgressStep] = useState('');
    
    // Birdia API result state
    const [birdiaResult, setBirdiaResult] = useState(null);
    
    // Existing detection ID (hardcoded for now, later loaded from backend)
    // Example: Set to "b43aae49-52da-4b44-bca8-eaf85b00bf62" to test with existing detection
    const [existingDetectionId, setExistingDetectionId] = useState(null); // Set to a UUID to reuse existing detection
    // const [existingDetectionId, setExistingDetectionId] = useState("b43aae49-52da-4b44-bca8-eaf85b00bf62"); // Set to a UUID to reuse existing detection

    const steps = [
        { id: 1, name: 'Bienvenue' },
        { id: 2, name: 'Diagnostic' },
        { id: 3, name: 'Résultats' },
        { id: 4, name: 'Action' }
    ];

    // Helper function to add a progress step
    const addProgressStep = (stepName, status = 'in-progress') => {
        setCurrentProgressStep(stepName);
        if (status === 'completed') {
            setProgressSteps(prev => [...prev, { name: stepName, status: 'completed' }]);
        }
    };

    // Function to create a buffer around coordinates
    const createBuffer = (lon, lat, radiusMeters = 4) => {
        // Approximation simple : 1 degré ≈ 111km
        const offset = radiusMeters / 111000;
        console.log(offset)
        return {
            "type": "Polygon",
            "coordinates": [[
                [lon - offset, lat - offset],
                [lon + offset, lat - offset],
                [lon + offset, lat + offset],
                [lon - offset, lat + offset],
                [lon - offset, lat - offset]
            ]]
        };
    };

    // Function to calculate centroid of a parcel
    const getCentroid = (geometry) => {
        // Les parcelles cadastrales sont des MultiPolygon
        const coordinates = geometry.coordinates[0][0]; // Premier polygone, premier anneau
        
        let sumLon = 0;
        let sumLat = 0;
        const numPoints = coordinates.length;
        
        coordinates.forEach(([lon, lat]) => {
            sumLon += lon;
            sumLat += lat;
        });
        
        return {
            lon: sumLon / numPoints,
            lat: sumLat / numPoints
        };
    };

    // Function to check if a point is inside a polygon (ray casting algorithm)
    const isPointInPolygon = (point, polygon) => {
        const [x, y] = point;
        let inside = false;
        
        for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            const [xi, yi] = polygon[i];
            const [xj, yj] = polygon[j];
            
            const intersect = ((yi > y) !== (yj > y))
                && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }
        
        return inside;
    };

    // Function to select the best parcel
    const selectBestParcel = (parcels, originLon, originLat) => {
        console.log('[DEBUG] ===== SÉLECTION DE LA PARCELLE =====');
        console.log('[DEBUG] Point GPS d\'origine:', [originLon, originLat]);
        console.log('[DEBUG] Nombre de parcelles à analyser:', parcels.length);

        const parcelAnalysis = parcels.map((parcel, index) => {
            const polygon = parcel.geometry.coordinates[0][0]; // MultiPolygon -> first polygon -> first ring
            const containsPoint = isPointInPolygon([originLon, originLat], polygon);
            const centroid = getCentroid(parcel.geometry);
            const distance = Math.sqrt(
                Math.pow(originLon - centroid.lon, 2) + 
                Math.pow(originLat - centroid.lat, 2)
            );

            console.log(`[DEBUG] Parcelle ${index + 1}:`);
            console.log(`[DEBUG]   - IDU: ${parcel.properties.idu}`);
            console.log(`[DEBUG]   - Surface: ${parcel.properties.contenance} m²`);
            console.log(`[DEBUG]   - Contient le point GPS: ${containsPoint ? 'OUI ✓' : 'NON'}`);
            console.log(`[DEBUG]   - Distance au centroid: ${distance.toFixed(6)}`);

            return { parcel, containsPoint, distance, centroid };
        });

        // Strategy 1: Select parcel that contains the GPS point
        const parcelsContainingPoint = parcelAnalysis.filter(p => p.containsPoint);
        if (parcelsContainingPoint.length > 0) {
            // If multiple parcels contain the point, select the closest one
            parcelsContainingPoint.sort((a, b) => a.distance - b.distance);
            const selected = parcelsContainingPoint[0];
            console.log('[DEBUG] ===== PARCELLE SÉLECTIONNÉE (contient le point GPS) =====');
            console.log('[DEBUG] IDU:', selected.parcel.properties.idu);
            console.log('[DEBUG] Surface:', selected.parcel.properties.contenance, 'm²');
            return selected.parcel;
        }

        // Strategy 2: Select closest parcel by distance
        parcelAnalysis.sort((a, b) => a.distance - b.distance);
        const selected = parcelAnalysis[0];
        console.log('[DEBUG] ===== PARCELLE SÉLECTIONNÉE (plus proche du point GPS) =====');
        console.log('[DEBUG] IDU:', selected.parcel.properties.idu);
        console.log('[DEBUG] Surface:', selected.parcel.properties.contenance, 'm²');
        console.log('[DEBUG] Distance:', selected.distance.toFixed(6));
        return selected.parcel;
    };

    // Function to generate UUID
    const generateUUID = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    // Function to convert MultiPolygon to Polygon
    const multiPolygonToPolygon = (geometry) => {
        if (geometry.type === 'MultiPolygon') {
            // Extract the first polygon from the MultiPolygon
            // MultiPolygon structure: coordinates = [[[polygon1]], [[polygon2]], ...]
            // Polygon structure: coordinates = [[exterior ring], [hole1], [hole2], ...]
            console.log('[DEBUG] Converting MultiPolygon to Polygon');
            return {
                type: 'Polygon',
                coordinates: geometry.coordinates[0] // Take the first polygon
            };
        }
        // If already a Polygon, return as is
        return geometry;
    };

    // Function to check if an existing detection already has results
    const checkExistingDetection = async (detectionId) => {
        console.log('[DEBUG] ===== CHECKING EXISTING DETECTION =====');
        console.log('[DEBUG] Detection ID:', detectionId);
        
        try {
            const response = await fetch(`https://api.birdia.fr/detections/${detectionId}`, {
                method: 'GET',
                headers: {
                    'x-api-key': process.env.REACT_APP_BIRDIA_API_KEY
                }
            });

            if (response.status === 404) {
                console.log('[DEBUG] Detection not found (404), will create new one');
                return { exists: false, hasResults: false };
            }

            if (!response.ok) {
                console.log('[DEBUG] Error checking detection:', response.status, response.statusText);
                return { exists: false, hasResults: false };
            }

            const result = await response.json();
            console.log('[DEBUG] Existing detection found:', result);
            
            // Check if detection has completed results (imageUrl and vggUrl available)
            const hasResults = result.imageUrl && result.vggUrl;
            console.log('[DEBUG] Detection has results:', hasResults);
            
            if (hasResults) {
                console.log('[DEBUG] Detection completed with results, will skip to results page');
                return { exists: true, hasResults: true, data: result };
            } else {
                console.log('[DEBUG] Detection exists but no results yet, status:', result.step?.status?.progression);
                
                // Check if detection is still processing
                if (result.step?.status?.progression === 'PROCESSING' || result.step?.status?.progression === 'PENDING') {
                    console.log('[DEBUG] Detection is still processing, will resume polling');
                    return { exists: true, hasResults: false, isProcessing: true, data: result };
                }
                
                // If detection failed or is in unknown state, we'll create a new one
                console.log('[DEBUG] Detection in unexpected state, will create new one');
                return { exists: false, hasResults: false };
            }
        } catch (error) {
            console.error('[ERROR] Error checking existing detection:', error);
            return { exists: false, hasResults: false };
        }
    };

    // Function to call Birdia API
    const callBirdiaAPI = async (selectedParcel, isSync) => {
        // Add progress step for satellite image retrieval
        addProgressStep('Récupération d\'images satellite récentes et qualitatives');
        
        const detectionId = generateUUID();
        const apiKey = process.env.REACT_APP_BIRDIA_API_KEY;

        console.log('[DEBUG] ===== APPEL API BIRDIA =====');
        console.log('[DEBUG] Detection ID:', detectionId);
        console.log('[DEBUG] Mode:', isSync ? 'SYNCHRONE' : 'ASYNCHRONE');
        console.log('[DEBUG] Surface parcelle:', selectedParcel.properties.contenance, 'm²');

        // Convert MultiPolygon to Polygon if necessary
        const geometry = multiPolygonToPolygon(selectedParcel.geometry);
        console.log('[DEBUG] Geometry type:', geometry.type);

        // Build the payload
        const payload = {
            needsImageOutput: true,
            emailReceiver: formData.email,
            zoneName: `${formData.address}, ${formData.zipCode} ${formData.city}`,
            geoServerProperties: null,
            detectableObjectModel: {
                modelName: "BP_TOITURE"
            },
            geoJsonZone: [
                {
                    type: "Feature",
                    geometry: geometry,
                    properties: {
                        idu: selectedParcel.properties.idu,
                        contenance: selectedParcel.properties.contenance
                    }
                }
            ]
        };

        console.log('[DEBUG] Payload:', JSON.stringify(payload, null, 2));

        const endpoint = isSync 
            ? `https://api.birdia.fr/detections/${detectionId}/sync`
            : `https://api.birdia.fr/detections/${detectionId}`;

        console.log('[DEBUG] Endpoint:', endpoint);

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': process.env.REACT_APP_BIRDIA_API_KEY
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`Birdia API error: ${response.status} ${response.statusText}`);
            }

            const result = await response.json();
            console.log('[DEBUG] Birdia API Response:', result);

            if (isSync) {
                // For sync mode, the detection is complete
                console.log('[DEBUG] Détection synchrone terminée');
                return result;
            } else {
                // For async mode, start polling
                console.log('[DEBUG] Détection asynchrone lancée, début du polling...');
                return await pollBirdiaDetection(detectionId, apiKey);
            }
        } catch (error) {
            console.error('[ERROR] Erreur Birdia API:', error);
            throw error;
        }
    };

    // Function to poll Birdia API for async detections
    const pollBirdiaDetection = async (detectionId, apiKey) => {
        let attempts = 0;
        let lastStepName = '';

        // Map Birdia step names to user-friendly messages
        const stepMessages = {
            'TILING': 'Découpage et préparation des images satellite',
            'MACHINE_DETECTION': 'Analyse par intelligence artificielle en cours',
            'POST_PROCESSING': 'Finalisation de l\'analyse et génération du rapport'
        };

        const poll = async () => {
            attempts++;
            console.log(`[DEBUG] Polling tentative ${attempts}...`);

            try {
                const response = await fetch(`https://api.birdia.fr/detections/${detectionId}`, {
                    method: 'GET',
                    headers: {
                        'x-api-key': process.env.REACT_APP_BIRDIA_API_KEY
                    }
                });

                if (!response.ok) {
                    throw new Error(`Polling error: ${response.status} ${response.statusText}`);
                }

                const result = await response.json();
                const currentStepName = result.step?.name;
                console.log('[DEBUG] Status:', result.step?.status?.progression);
                console.log('[DEBUG] Current Step:', currentStepName);

                // Update progress if step has changed and is not REQUEST_ACCEPTED
                if (currentStepName && currentStepName !== 'REQUEST_ACCEPTED' && currentStepName !== lastStepName) {
                    // Mark previous step as completed
                    if (lastStepName === 'TILING') {
                        addProgressStep('Découpage et préparation des images satellite', 'completed');
                    } else if (lastStepName === 'MACHINE_DETECTION') {
                        addProgressStep('Analyse par intelligence artificielle en cours', 'completed');
                    }
                    
                    lastStepName = currentStepName;
                    const userFriendlyMessage = stepMessages[currentStepName] || currentStepName;
                    
                    // Mark satellite image step as completed if we're moving to processing steps
                    if (currentStepName === 'TILING') {
                        addProgressStep('Récupération d\'images satellite récentes et qualitatives', 'completed');
                    }
                    
                    addProgressStep(userFriendlyMessage);
                }

                // Check if detection is finished
                if (result.geoJsonUrl) {
                    // Mark POST_PROCESSING as completed if it was the last step
                    if (lastStepName === 'POST_PROCESSING') {
                        addProgressStep('Finalisation de l\'analyse et génération du rapport', 'completed');
                    }
                    
                    // Add placeholder for future S3/VGG file retrieval
                    addProgressStep('Récupération des fichiers d\'analyse');
                    addProgressStep('Récupération des fichiers d\'analyse', 'completed');
                    
                    console.log('[DEBUG] ===== DÉTECTION TERMINÉE =====');
                    console.log('[DEBUG] GeoJSON URL:', result.geoJsonUrl);
                    console.log('[DEBUG] Image URL:', result.imageUrl);
                    console.log('[DEBUG] PDF URL:', result.pdfUrl);
                    return result;
                }

                // Check if failed
                if (result.step?.status?.health === 'FAILED') {
                    throw new Error('La détection a échoué');
                }

                // Continue polling - wait and poll again
                await new Promise(resolve => setTimeout(resolve, 5000)); // Wait 5 seconds
                return await poll();
            } catch (error) {
                console.error('[ERROR] Erreur lors du polling:', error);
                throw error;
            }
        };

        return await poll();
    };

    // Function to handle geocoding and cadastral query
    const handleDiagnostic = async () => {
        if (!formData.address || !formData.zipCode || !formData.city) {
            alert('Veuillez remplir tous les champs d\'adresse');
            return;
        }

        setDiagLaunched(true);
        setProgressSteps([]);
        setCurrentProgressStep('');

        try {
            // Check if we have an existing detection ID to reuse
            if (existingDetectionId) {
                console.log('[DEBUG] ===== CHECKING FOR EXISTING DETECTION =====');
                addProgressStep('Vérification d\'une analyse existante');
                
                const checkResult = await checkExistingDetection(existingDetectionId);
                
                if (checkResult.hasResults) {
                    // Detection already has complete results, skip to results page
                    console.log('[DEBUG] Using existing detection results, skipping to results page');
                    addProgressStep('Vérification d\'une analyse existante', 'completed');
                    addProgressStep('Analyse existante trouvée, chargement des résultats');
                    addProgressStep('Analyse existante trouvée, chargement des résultats', 'completed');
                    
                    setBirdiaResult(checkResult.data);
                    setTimeout(() => setCurrentStep(3), 1000);
                    return;
                } else if (checkResult.isProcessing) {
                    // Detection is still processing, resume polling
                    console.log('[DEBUG] Detection still processing, resuming polling');
                    addProgressStep('Vérification d\'une analyse existante', 'completed');
                    addProgressStep('Analyse en cours détectée, reprise du suivi');
                    
                    const result = await pollBirdiaDetection(existingDetectionId);
                    setBirdiaResult(result);
                    setTimeout(() => setCurrentStep(3), 1000);
                    return;
                } else {
                    // Detection not found or failed, continue with normal flow
                    console.log('[DEBUG] No valid existing detection found, proceeding with new analysis');
                    addProgressStep('Vérification d\'une analyse existante', 'completed');
                    addProgressStep('Nouvelle analyse requise');
                }
            }
            
            // Étape 1: Récupérer les coordonnées GPS de l'adresse
            addProgressStep('Récupération de la position GPS de votre domicile');
            
            const addressQuery = `${formData.address} ${formData.zipCode} ${formData.city}`;
            const geocodeUrl = `https://data.geopf.fr/geocodage/search?q=${encodeURIComponent(addressQuery)}`;
            
            console.log('[DEBUG] Geocoding URL:', geocodeUrl);
            
            const geocodeResponse = await fetch(geocodeUrl);
            const geocodeData = await geocodeResponse.json();
            
            console.log('[DEBUG] Geocoding Response:', geocodeData);

            if (!geocodeData.features || geocodeData.features.length === 0) {
                alert('Adresse non trouvée. Veuillez vérifier les informations saisies.');
                setDiagLaunched(false);
                return;
            }

            // Récupérer les coordonnées (longitude, latitude)
            const coordinates = geocodeData.features[0].geometry.coordinates;
            const [lon, lat] = coordinates;

            console.log('[DEBUG] Coordinates found:', { longitude: lon, latitude: lat });
            
            // Mark GPS step as completed
            addProgressStep('Récupération de la position GPS de votre domicile', 'completed');

            // Étape 2: Créer le buffer autour des coordonnées
            addProgressStep('Récupération des données cadastrales');
            
            const buffer = createBuffer(lon, lat, 2);
            
            // Logger les coordonnées du buffer
            console.log('[DEBUG] Buffer coordinates:', JSON.stringify(buffer, null, 2));

            // Étape 3: Requêter l'API cadastre avec le buffer
            const cadastreUrl = `https://apicarto.ign.fr/api/cadastre/parcelle?geom=${encodeURIComponent(JSON.stringify(buffer))}`;
            
            console.log('[DEBUG] Cadastre API URL:', cadastreUrl);
            
            const cadastreResponse = await fetch(cadastreUrl);
            const cadastreData = await cadastreResponse.json();
            
            // Logger les résultats
            console.log('[DEBUG] Cadastre API Results:', cadastreData);
            
            // Mark cadastral step as completed
            addProgressStep('Récupération des données cadastrales', 'completed');

            // ===== SYNTHÈSE GEOJSON =====
            console.log('[DEBUG] ===== GÉNÉRATION GEOJSON =====');
            
            // Helper function to convert bbox to LineString (rectangle perimeter)
            const bboxToLineString = (bbox) => {
                // bbox format: [minLon, minLat, maxLon, maxLat]
                const [minLon, minLat, maxLon, maxLat] = bbox;
                return {
                    type: "LineString",
                    coordinates: [
                        [minLon, minLat],
                        [maxLon, minLat],
                        [maxLon, maxLat],
                        [minLon, maxLat],
                        [minLon, minLat]
                    ]
                };
            };

            // Build GeoJSON FeatureCollection
            const geojsonFeatures = [];

            // 1. Add original GPS point
            geojsonFeatures.push({
                type: "Feature",
                properties: {
                    name: "Point GPS d'origine",
                    type: "origin_point",
                    address: addressQuery,
                    "marker-color": "#ff0000",
                    "marker-size": "large",
                    "marker-symbol": "star"
                },
                geometry: {
                    type: "Point",
                    coordinates: [lon, lat]
                }
            });

            // 2. Add buffer polygon
            geojsonFeatures.push({
                type: "Feature",
                properties: {
                    name: "Buffer de recherche",
                    type: "search_buffer",
                    radius_meters: 2,
                    "stroke": "#0000ff",
                    "stroke-width": 2,
                    "stroke-opacity": 0.8,
                    "fill": "#0000ff",
                    "fill-opacity": 0.1
                },
                geometry: buffer
            });

            // 3. Add bbox LineStrings and parcel polygons for each cadastral feature
            if (cadastreData.features && cadastreData.features.length > 0) {
                cadastreData.features.forEach((parcel, index) => {
                    // Add bbox as LineString
                    if (parcel.bbox) {
                        geojsonFeatures.push({
                            type: "Feature",
                            properties: {
                                name: `BBox parcelle ${parcel.properties.numero}`,
                                type: "parcel_bbox",
                                parcel_id: parcel.properties.idu,
                                parcel_numero: parcel.properties.numero,
                                parcel_section: parcel.properties.section,
                                "stroke": "#ffa500",
                                "stroke-width": 2,
                                "stroke-opacity": 0.6
                            },
                            geometry: bboxToLineString(parcel.bbox)
                        });
                    }

                    // Add parcel geometry (MultiPolygon)
                    geojsonFeatures.push({
                        type: "Feature",
                        properties: {
                            name: `Parcelle ${parcel.properties.numero}`,
                            type: "parcel_geometry",
                            idu: parcel.properties.idu,
                            numero: parcel.properties.numero,
                            section: parcel.properties.section,
                            feuille: parcel.properties.feuille,
                            contenance: parcel.properties.contenance,
                            commune: parcel.properties.nom_com,
                            code_insee: parcel.properties.code_insee,
                            "stroke": "#00ff00",
                            "stroke-width": 2,
                            "stroke-opacity": 0.9,
                            "fill": "#00ff00",
                            "fill-opacity": 0.2
                        },
                        geometry: parcel.geometry
                    });
                });
            }

            // Create complete FeatureCollection
            const geojsonOutput = {
                type: "FeatureCollection",
                features: geojsonFeatures
            };

            // Log the GeoJSON in a copy-paste friendly format
            console.log('[DEBUG] ===== GEOJSON COMPLET (copier-coller dans geojson.io) =====');
            console.log(JSON.stringify(geojsonOutput, null, 2));
            console.log('[DEBUG] ===== FIN GEOJSON =====');
            console.log('[DEBUG]');
            console.log('[DEBUG] Instructions:');
            console.log('[DEBUG] 1. Copiez tout le JSON ci-dessus (depuis {"type":"FeatureCollection" jusqu\'à la dernière })');
            console.log('[DEBUG] 2. Allez sur https://geojson.io');
            console.log('[DEBUG] 3. Collez le JSON dans l\'éditeur de droite');
            console.log('[DEBUG] 4. La carte s\'affichera automatiquement avec:');
            console.log('[DEBUG]    - Point rouge: GPS d\'origine');
            console.log('[DEBUG]    - Rectangle bleu: Buffer de recherche');
            console.log('[DEBUG]    - Rectangles orange: BBox de chaque parcelle');
            console.log('[DEBUG]    - Polygones verts: Géométries des parcelles cadastrales');
            console.log('[DEBUG]');
            // ============================

            // ===== SÉLECTION DE LA PARCELLE ET APPEL BIRDIA API =====
            if (cadastreData.features && cadastreData.features.length > 0) {
                // Select the best parcel
                const selectedParcel = selectBestParcel(cadastreData.features, lon, lat);
                console.log('[DEBUG]');
                console.log('[DEBUG] ===== PRÉPARATION APPEL BIRDIA API =====');
                
                // Determine if sync or async based on surface
                const surface = selectedParcel.properties.contenance;
                const isSync = surface < 1000;
                
                console.log('[DEBUG] Surface de la parcelle:', surface, 'm²');
                console.log('[DEBUG] Mode de détection:', isSync ? 'SYNCHRONE (< 1000m²)' : 'ASYNCHRONE (>= 1000m²)');
                
                try {
                    // Call Birdia API
                    const birdiaResult = await callBirdiaAPI(selectedParcel, isSync);
                    
                    console.log('[DEBUG]');
                    console.log('[DEBUG] ===== RÉSULTAT BIRDIA API =====');
                    console.log('[DEBUG] Detection ID:', birdiaResult.id);
                    console.log('[DEBUG] Status:', birdiaResult.step?.status?.progression);
                    console.log('[DEBUG] Health:', birdiaResult.step?.status?.health);
                    
                    if (birdiaResult.geoJsonUrl) {
                        console.log('[DEBUG] GeoJSON Result URL:', birdiaResult.geoJsonUrl);
                    }
                    if (birdiaResult.imageUrl) {
                        console.log('[DEBUG] Image URL:', birdiaResult.imageUrl);
                    }
                    if (birdiaResult.pdfUrl) {
                        console.log('[DEBUG] PDF URL:', birdiaResult.pdfUrl);
                    }
                    
                    console.log('[DEBUG] Résultat complet:', JSON.stringify(birdiaResult, null, 2));
                    console.log('[DEBUG]');
                    
                    // Store the result in state for Step3Results
                    setBirdiaResult(birdiaResult);
                    
                } catch (birdiaError) {
                    console.error('[ERROR] Erreur lors de l\'appel Birdia API:', birdiaError);
                    alert(`Erreur Birdia API: ${birdiaError.message}`);
                }
            } else {
                console.log('[DEBUG] Aucune parcelle trouvée, impossible d\'appeler Birdia API');
            }
            // ============================

            // Passer à l'étape suivante après traitement
            setTimeout(() => setCurrentStep(3), 2000);
            
        } catch (error) {
            console.error('[ERROR] Erreur lors du diagnostic:', error);
            alert('Une erreur est survenue lors du diagnostic. Consultez la console pour plus de détails.');
            setDiagLaunched(false);
        }
    };

    return (
        <div style={{ 
            minHeight: '100vh',
            background: 'linear-gradient(to bottom, var(--background-light), white)',
            padding: '2rem 1rem',
            overflow: 'auto'
        }}>
            <StepIndicator steps={steps} currentStep={currentStep} />

            <div style={{ maxWidth: '90vw', margin: '0 auto' }}>
                {currentStep === 1 && <Step1Welcome formData={formData} setFormData={setFormData} setCurrentStep={setCurrentStep} />}
                {currentStep === 2 && <Step2Diagnostic diagLaunched={diagLaunched} handleDiagnostic={handleDiagnostic} progressSteps={progressSteps} currentProgressStep={currentProgressStep} />}
                {currentStep === 3 && <Step3Results setCurrentStep={setCurrentStep} setDiagLaunched={setDiagLaunched} birdiaResult={birdiaResult} />}
            </div>

            {/* Bouton retour */}
            {currentStep > 1 && !diagLaunched && (
                <div style={{ maxWidth: '800px', margin: '2rem auto 0', textAlign: 'center' }}>
                    <button
                        onClick={() => setCurrentStep(currentStep - 1)}
                        style={{
                            color: 'var(--link)',
                            fontWeight: '500',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '1rem'
                        }}
                        onMouseOver={(e) => e.target.style.opacity = '0.8'}
                        onMouseOut={(e) => e.target.style.opacity = '1'}
                    >
                        ← Retour
                    </button>
                </div>
            )}
        </div>
    );
};

export default RoofAnalyserIa;
